/** @format */
import { AxiosRequestConfig } from 'axios';

import { client } from '@toucan/client/global/axios';
import { MarketCode, MarketSlug } from '@toucan/client/global/market';

import {
    ShippingOption,
    ShippingOptionType,
} from '@toucan/client/core/shipping';
import { transformShippingOptions } from '@toucan/client/core/shipping/helpers';

export async function fetchCollectionOptions(
    region: string | undefined, // Delivery region (UK Postcode, US state)
    country: string | undefined, // 2-letter country code
    market: MarketCode,
    language: MarketSlug
): Promise<ShippingOption[]> {
    const config: AxiosRequestConfig = {
        params: {
            delivery_region: region,
        },
        headers: {
            'X-Market': market.toLowerCase(),
            'X-Language': language,
        },
    };

    const response = await client.get(
        `/couriers/options/legacy/collection/${country}`,
        config
    );

    return transformShippingOptions(
        response.data,
        ShippingOptionType.COLLECTION
    );
}
